import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { GLOBAL_DATE_FORMAT } from '../../constants';
import DropdownMenu from '../DropdownMenu';
import CalendarSmall from '../CalendarSmall';

import './style.scss';

const propTypes = {
  className: PropTypes.string,
  onEventChange: PropTypes.func,
  ranges: PropTypes.shape({}),
  enabledEarlierDates: PropTypes.bool,
  disabledWeeky: PropTypes.bool,
  enableDefaultOrderTranslation: PropTypes.bool,
  isDateUpdated: PropTypes.bool,
  enableDefaultLicense: PropTypes.bool,
};

const defaultProps = {
  className: '',
  onChange: () => { },
  ranges: {
    startDate: moment(),
    endDate: moment(),
    key: 'selection',
  },
  displayFormat: '',
  enabledEarlierDates: false,
  disabledWeeky: false,
  enableDefaultOrderTranslation: false,
  isDateUpdated: false,
  enableDefaultLicense: false,
};

const INITAL_STATES = {
  isChecked: false,
};

class TFVDateRangePicker extends Component {
  constructor(props) {
    super(props);
    this.state = INITAL_STATES;
  }

  handleToggleSwitchChange = () => {
    const { isChecked } = this.state;
    this.setState({
      isChecked: !isChecked,
    });
  };

  render() {
    const {
      className,
      onChange,
      ranges,
      enabledEarlierDates,
      displayFormat,
      disabledWeeky,
      disabled,
      enableDefaultOrderTranslation,
      ariaLabel,
      enableDefaultLicense,
    } = this.props;
    const { isChecked } = this.state;

    // Ensure startDate and endDate are moment objects
    const startDate = ranges.startDate ? (moment.isMoment(ranges.startDate) ? ranges.startDate : moment(ranges.startDate)) : null;
    const endDate = ranges.endDate ? (moment.isMoment(ranges.endDate) ? ranges.endDate : moment(ranges.endDate)) : null;

    const buttondisplayFormat = displayFormat !== '' ? displayFormat : GLOBAL_DATE_FORMAT;
    const button = (
      <div className={`tv-form__date-field ${disabled ? 'text-black-50' : ''}`}>
        {!startDate && !endDate
          ? 'Välj Datum'
          : startDate && endDate && startDate.isSame(endDate, 'day')
            ? endDate.format(buttondisplayFormat)
            : startDate && endDate
              ? `${startDate.format(buttondisplayFormat)} to ${endDate.format(
                buttondisplayFormat,
              )}`
              : 'Välj Datum'}
      </div>
    );
    return (
      <DropdownMenu
        className={`tv-date-range-picker__container ${className}`}
        ref={el => {
          this.filterElement = el;
        }}
        button={button}
        disabled={disabled}
        ariaLabel={ariaLabel}
      >
        <div className="tv-date-range-picker__dialog">
          <div className="calendar-small">
            <CalendarSmall
              className="calendar-small"
              ranges={{
                ...ranges,
                startDate,
                endDate
              }}
              isMinDate
              onEventChange={e => onChange(e, this.filterElement)}
              isChecked={isChecked}
              minDateSet={
                enabledEarlierDates
                  ? moment().subtract(20, 'month').toDate()
                  : enableDefaultOrderTranslation
                    ? moment().add(6, 'days') : enableDefaultLicense ? moment().startOf('day').toDate()
                      : moment().add(1, 'days').startOf('day').toDate()
              }
              maxDateSet={moment().add(12, 'month').toDate()}
              showToggle={false}
              onToggleSwitchChange={this.handleToggleSwitchChange}
              {...(enabledEarlierDates === true
                ? {
                  isMinDate: false,
                }
                : {})}
              {...(disabledWeeky === true
                ? {
                  showToggle: false,
                }
                : {})}
            />
          </div>
        </div>
      </DropdownMenu>
    );
  }
}

TFVDateRangePicker.propTypes = propTypes;
TFVDateRangePicker.defaultProps = defaultProps;

export default TFVDateRangePicker;
